import React from "react";
import { Reveal } from "../Reveal";
import mountainPhoto from "../../assets/belief.webp";

const items = [
  {
    title: "1:1 samtaler og forløb",
    text:
      "Vi tager en indledende telefonisk snak og taler om, hvad der fylder, og hvad du har brug for sparring eller hjælp til. Enten til dig personligt eller til dit team. Vi mærker ligeledes, om der er kemi og taler om, hvordan et forløb kan se ud i forhold, hvad vi skal arbejde med samt de praktiske detaljer.",
    listTitle: "Hvad får du ud af et 1:1 forløb:",
    points: [
      "Et fortroligt, trygt og nærværende rum med tid til dig",
      "Større forståelse for dine tanker, følelser og handlemønstre",
      "Klarhed over, hvad der er vigtigt for dig, og hvilken retning du ønsker at gå",
      "Værktøjer til at håndtere indre og ydre forventninger, pres, tvivl og modgang",
      "Evnen til at bevare fokus og finde tilbage efter fejl eller svære situationer",
      "Mere bevidste valg – fremfor automatisk at falde tilbage i gamle mønstre",
      "Redskaber til at slippe det, der er uden for din kontrol",
      "Større tillid til og tro på dig selv og mod til at handle på det, du vil",
      "En sparringspartner der altid er der for dig",
    ],
  },
  {
    title: "Teamcoaching",
    text:
      "Vi tager en indledende snak og taler om, hvem teamet er, og hvad det har brug for at styrke. Efter en forventningsafstemning aftaler vi, hvordan et forløb skal se ud for gruppen.",
    listTitle: "Teamet får følgende ud af et forløb:",
    points: [
      "Større bevidsthed omkring de dynamikker, der præger samarbejdet",
      "Forståelse for forskelligheder, og hvordan det kan bruges som en styrke",
      "En fælles retning og klarhed over roller, ansvar og forventninger til hinanden",
      "Et fælles sprog og konkrete værktøjer, der gør det lettere at omsætte refleksioner til handling",
      "Mere åben, ærlig og konstruktiv kommunikation",
      "Sundere relationer og psykologisk tryghed",
      "En kultur hvor alle bidrager til fællesskabet: ingen over, men med plads til individuelle mål",
      "Større trivsel, mere glæde og bedre præstationer – fælles og individuelt",
    ],
  },
];

const PreviewCoaching = () => (
  <section id="coaching" className="relative overflow-hidden bg-[#F4F1EC] pt-16 sm:pt-24" data-testid="preview-section-coaching">
    <div className="pointer-events-none absolute -right-32 -top-10 h-[440px] w-[440px] rounded-full bg-[#852936]/[0.07] blur-[130px]" />
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <div className="mb-7 h-0.5 w-12 bg-[#852936]" />
        <h2
          className="font-display text-4xl font-semibold leading-[1.02] tracking-tight text-[#852936] sm:text-5xl md:text-6xl lg:text-7xl"
          data-testid="preview-heading-coaching"
        >
          Coaching
          <br />
          Mentaltræning
          <br />
          Mentorforløb
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-6 md:grid-cols-2 sm:mt-16">
        {items.map((it, i) => (
          <Reveal key={it.title} delay={i * 120}>
            <div
              className="h-full rounded-3xl border border-black/[0.06] bg-white p-5 sm:p-7 preview-shadow-soft"
              data-testid={`preview-coaching-card-${i}`}
            >
              <h3 className="font-display text-xl font-semibold text-[#111827] sm:text-2xl">
                {it.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#111827]/70">{it.text}</p>
              <p className="mt-5 text-[15px] font-semibold leading-relaxed text-[#111827]">{it.listTitle}</p>
              <ul className="mt-2 space-y-1 text-[15px] leading-relaxed text-[#111827]/70" data-testid={`preview-coaching-points-${i}`}>
                {it.points.map((point) => (
                  <li key={point} className="flex gap-3">
                    <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#852936]" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>

    <div className="relative mt-16 sm:mt-24">
      <img
        src={mountainPhoto}
        alt="Bjerg ved solopgang"
        className="h-72 w-full object-cover sm:h-[520px]"
        style={{ objectPosition: "center 60%" }}
        data-testid="preview-coaching-image"
      />
    </div>
  </section>
);

export default PreviewCoaching;
